module.exports = __webpack_public_path__ + "img/mode.22dc583a.png";